import { render, staticRenderFns } from "./errorModal.vue?vue&type=template&id=6cd6e1b8&scoped=true&"
import script from "./errorModal.vue?vue&type=script&lang=ts&"
export * from "./errorModal.vue?vue&type=script&lang=ts&"
import style0 from "./errorModal.vue?vue&type=style&index=0&id=6cd6e1b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd6e1b8",
  null
  
)

export default component.exports